var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam-body" },
    [
      _vm.readOnly
        ? _c("div", { staticClass: "subjective-content" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.checkValue[_vm.subjects.examQuestionsId] &&
                    _vm.checkValue[_vm.subjects.examQuestionsId].length
                    ? _vm.checkValue[_vm.subjects.examQuestionsId]
                    : ""
                ) +
                " "
            ),
          ])
        : _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请答题，答题框可在右下角拉伸",
              rows: 12,
              readonly: _vm.readOnly,
              maxlength: _vm.maxLength,
              "show-word-limit": "",
              ondrop: "return false",
            },
            on: { input: _vm.handleCheck },
            model: {
              value: _vm.checkValue[_vm.subjects.examQuestionsId],
              callback: function ($$v) {
                _vm.$set(_vm.checkValue, _vm.subjects.examQuestionsId, $$v)
              },
              expression: "checkValue[subjects.examQuestionsId]",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }